// src/components/LoginOAuthButtons.js
import React from "react";
import GoogleLogo from "../assets/google-logo.png";
import FacebookLogo from "../assets/facebook-logo.png";
import { Box, Button } from "@mui/material";
import getApiBase from "./getApiBase";


export default function LoginOAuthButtons({
  role
})
 {
  
  return (
    <Box sx={{ display: "flex", justifyContent: "center", gap: 2, mb: 2 }}>
      {/* Temporarily disabled - Bug #6: Subscriptions not listing when signed in with google oauth */}
      {/* TODO: Fix subscription listing for Google OAuth users - subscriptions are linked to mechanic_id but OAuth may use different ID */}
      {/* <Button
        variant="outlined"
        onClick={() => (window.location.href = `${getApiBase()}/api/auth/google?state=${role}`
        //console.log("LoginOAuthButtons rendered with role:", role, "API Base", getApiBase())
      )}

      >
        <img src={GoogleLogo} alt="Google" width={30} height={30} />
      </Button> */}
      {/*<Button
        variant="outlined"
        onClick={() => (window.location.href = `${getApiBase()}/api/auth/facebook?state=${role}`)}

      >
        <img src={FacebookLogo} alt="Facebook" width={20} height={20} />
      </Button>*/}
    </Box>
  )
};

